import { render, staticRenderFns } from "./ModalConfirmacao.vue?vue&type=template&id=9cc12f64&scoped=true"
import script from "./ModalConfirmacao.vue?vue&type=script&lang=js"
export * from "./ModalConfirmacao.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmacao.vue?vue&type=style&index=0&id=9cc12f64&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc12f64",
  null
  
)

export default component.exports